import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PhysicianAccreditation, PhysicianAccreditationData } from '../../../interfaces/masters/physician-accreditation';
import { PhysicianAccreditationApi } from '../api/physician-accreditation.api';

@Injectable()
export class PhysicianAccreditationService extends PhysicianAccreditationData {

  constructor(private api: PhysicianAccreditationApi) { 
    super(); 
  }

  list(url: string): Observable<PhysicianAccreditation[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<PhysicianAccreditation>{
      return this.api.getById(url); 
  }

  create(url: string, data:PhysicianAccreditation[]): Observable<PhysicianAccreditation> {
    return this.api.add(url,data);
    
  }

  update(url: string, data:PhysicianAccreditation): Observable<PhysicianAccreditation> {
    return this.api.update(url,data);
  }  

  delete(url: string): Observable<boolean> { 
    return this.api.delete(url);
  } 


}
